import { FC } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { FilterInputSegment } from '../../../../../../brunswick/components/pages/Collection/sections/CollectionGridSection/FilterModal/FilterInputSegment'
import { useProductReviewFilters } from '../../../../../../lib/hooks/useProductReviewFilters'
import { MultipleSelectFilter } from '../MultipleSelectFilter'
import { RatingsFilter } from '../RatingsFilter'
import { FilterField, OnFilterFieldChange } from '../types'

export const FiltersList: FC<{
  fields: FilterField[]
  onRatingChange: OnFilterFieldChange
}> = ({ fields, onRatingChange }) => {
  const {
    magnolia: {
      reviewsPage: {
        filters: { filter: filterFixtures },
      },
    },
  } = useTranslation()
  const { filters } = useProductReviewFilters()

  return (
    <>
      <FilterInputSegment
        filterCount={5}
        isExpandedInitially={true}
        label={filterFixtures.rating.title}
        selectedFilterCount={filters.rating ? filters.rating.length : 0}
      >
        <RatingsFilter value={filters.rating ?? []} onChange={onRatingChange} />
      </FilterInputSegment>

      {fields.map(({ field, value, onChange }) => {
        return (
          <FilterInputSegment
            filterCount={field.values.length}
            isExpandedInitially={true}
            key={field.fieldId}
            label={field.localizedName ?? field.name}
            selectedFilterCount={value.length}
          >
            <MultipleSelectFilter {...{ value, onChange }} items={field.values} />
          </FilterInputSegment>
        )
      })}
    </>
  )
}
